import { useCallback, useEffect, useState } from "react";
import Lenis from "lenis";
import { api } from "../lib/api";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Services from "../components/Services";
import Parts from "../components/Parts";
import Inventory from "../components/Inventory";
import About from "../components/About";
import Gallery from "../components/Gallery";
import Videos from "../components/Videos";
import Testimonials from "../components/Testimonials";
import BookingDialog from "../components/BookingDialog";
import Footer from "../components/Footer";

export default function Home() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [prefill, setPrefill] = useState(null);
  const [content, setContent] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  useEffect(() => {
    api.get("/content").then((res) => setContent(res.data)).catch(() => {});
  }, []);

  const openBooking = useCallback((data) => {
    setPrefill(data || null);
    setBookingOpen(true);
  }, []);

  return (
    <div className="bg-asphalt text-slate-100 min-h-screen" data-testid="home-page">
      <Navbar onBook={() => openBooking()} />
      <main>
        <Hero onBook={() => openBooking()} content={content} />
        <Marquee items={content?.marquee_items} />
        <Services onBook={openBooking} content={content} />
        <Parts onEnquire={openBooking} content={content} />
        <Inventory onEnquire={openBooking} content={content} />
        <About content={content} />
        <Gallery content={content} />
        <Videos content={content} />
        <Testimonials content={content} />
      </main>
      <Footer content={content} />
      <BookingDialog open={bookingOpen} onOpenChange={setBookingOpen} prefill={prefill} />
    </div>
  );
}
